<div class="spinner center" *ngIf="isLoading; else showModal"></div>
<ng-template #showModal>
  <p *ngIf="contentRetrievalError">
    Error Retrieving content - Issue retrieving content from the CMS
  </p>
  <div class="wrapper" *ngIf="!contentRetrievalError">
    <h2 class="title">{{ modalData.title }}</h2>

    <p class="content">{{ modalData.content }}</p>

    <div class="button-container">
      <button type="button" (click)="update()">
        {{ modalData.update_account_button_text }}
      </button>

      <button type="button" (click)="dontUpdate()">
        {{ modalData.dont_update_account_button_text }}
      </button>
    </div>
  </div>
</ng-template>
